module.exports = __webpack_public_path__ + "static/media/progress-base.77fe3b55.png";